<script>
import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {vanBanNoiBoModel} from "@/models/vanBanNoiBoModel";
import {required} from "vuelidate/lib/validators";
import Multiselect from "vue-multiselect";
import vue2Dropzone from "vue2-dropzone";
import {notifyModel} from "@/models/notifyModel";
import Swal from "sweetalert2";
import moment from "moment";
import {CURRENT_USER} from "@/helpers/currentUser";

export default {
  page: {
    title: "Văn bản nội bộ",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    Multiselect,
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      title: "Văn bản nội bộ",
      items: [
        {
          text: "D-Office",
          href: "/"
        },
        {
          text: "Văn bản nội bộ",
          href: "/van-ban-noi-bo"
        },
        {
          text: "Danh sách",
          active: true
        }
      ],
      data: [],
      showModal: false,
      showDetail: false,
      detailModel: null,
      showDeleteModal: false,
      showSelectVBDiModal: false,
      showSelectVBDenModal: false,
      submitted: false,
      model: vanBanNoiBoModel.baseJson(),
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      numberOfElement: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      filter: null,
      filterOn: [],
      isBusy: false,
      sortBy: "modifiedAt",
      sortDesc: true,
      itemFilter: {
        title: null,
        loaiVanBan: null,
        linhVuc: null,
      },
      fields: [],
      optionsLoaiVanBan: [],
      optionsLinhVuc: [],
      optionsDonVi: [],
      optionsUser: [],

      // Dropzone
      apiUrl: process.env.VUE_APP_API_URL,
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 10,
        maxFilesize: 60,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".doc,.docx,.xlsx,.xls,.pdf,.zip,.rar,.pptx,.csv",
      },

      // Select from VanBanDi/VanBanDen
      listVanBanDi: [],
      listVanBanDen: [],
      totalRowsVBDi: 0,
      totalRowsVBDen: 0,
      currentPageVBDi: 1,
      currentPageVBDen: 1,
      perPageVBDi: 10,
      perPageVBDen: 10,
      filterVBDi: null,
      filterLoaiVBDi: null,
      filterLinhVucDi: null,
      filterVBDen: null,
      filterLoaiVBDen: null,
      filterLinhVucDen: null,
      loadingVBDi: false,
      loadingVBDen: false,

      isCollapseSearch: false,
      showButtonSave: true,
      currentUserRoles: CURRENT_USER.ROLES,

      // File preview
      showFilePreview: false,
      previewFiles: [],
      activePreviewIndex: 0,
      previewLoading: true,
      previewBlobUrl: null,
      previewError: false,
    };
  },
  validations: {
    model: {
      trichYeu: {required},
      loaiVanBan: {required},
      linhVuc: {required},
    },
  },
  computed: {
    isAdmin() {
      return this.currentUserRoles && this.currentUserRoles.find(x => x.code === '0000');
    },
    computedFields() {
      let fields = [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '30px', minWidth: '30px'},
          class: "text-center content-capso",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "trichYeu",
          label: "Trích yếu",
          thStyle: {width: 'auto', minWidth: '300px'},
          class: "content-capso",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: "loaiVanBan",
          label: "Loại văn bản",
          thStyle: {width: '130px', minWidth: '130px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
        {
          key: "linhVuc",
          label: "Lĩnh vực",
          thStyle: {width: '130px', minWidth: '130px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
      ];
      if (this.isAdmin) {
        fields.push({
          key: 'process',
          label: '',
          thStyle: {width: '150px', minWidth: '150px'},
          class: " text-center btn-process ",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        });
      }
      return fields;
    },
  },
  async created() {
    this.getLoaiVanBan();
    this.getLinhVuc();
    this.getDonVi();
    this.getUser();
  },
  methods: {
    async fnGetList() {
      this.$refs.tblList?.refresh();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        loaiVanBan: this.itemFilter.loaiVanBan,
        linhVuc: this.itemFilter.linhVuc,
        content: this.itemFilter.title,
      }
      this.loading = true;

      try {
        let promise = this.$store.dispatch("vanBanNoiBoStore/getPagingParams", params);
        return promise.then(resp => {
          let items = resp.data.data;
          this.totalRows = resp.data.totalRows;
          this.numberOfElement = resp.data.data.length;
          this.loading = false;
          return items || [];
        });
      } finally {
        this.loading = false;
      }
    },
    handleCreate() {
      this.model = vanBanNoiBoModel.baseJson();
      this.submitted = false;
      this.showModal = true;
    },
    hasFiles() {
      const hasExisting = this.model.file && this.model.file.length > 0;
      const hasUploaded = this.model.uploadFiles && this.model.uploadFiles.length > 0;
      return hasExisting || hasUploaded;
    },
    async handleSubmit(e) {
      if (e) e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid || !this.hasFiles()) {
        return;
      }

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
      });

      if (this.model.id != null && this.model.id) {
        await this.$store.dispatch("vanBanNoiBoStore/update", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.model = vanBanNoiBoModel.baseJson();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          loader.hide();
        });
      } else {
        await this.$store.dispatch("vanBanNoiBoStore/create", this.model).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showModal = false;
            this.model = vanBanNoiBoModel.baseJson();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          loader.hide();
        });
      }
    },
    async handleUpdate(id) {
      await this.$store.dispatch("vanBanNoiBoStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.model = res.data;
          this.submitted = false;
          this.showModal = true;
        }
      });
    },
    async handleShowDetail(id) {
      await this.$store.dispatch("vanBanNoiBoStore/getById", id).then((res) => {
        if (res.resultCode == "SUCCESS") {
          this.detailModel = res.data;
          this.showDetail = true;
        }
      });
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
    async handleDelete() {
      if (this.model.id != null && this.model.id) {
        await this.$store.dispatch("vanBanNoiBoStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
            this.model = vanBanNoiBoModel.baseJson();
            this.$refs.tblList.refresh();
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        });
      }
    },

    // File upload handlers
    addThisFile(file, response) {
      if (this.model) {
        if (this.model.uploadFiles == null || this.model.uploadFiles.length <= 0) {
          this.model.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.model.uploadFiles.push({
          fileId: fileSuccess.id,
          fileName: fileSuccess.fileName,
          ext: fileSuccess.ext
        });
      }
    },
    removeExistingFile(index) {
      this.model.file.splice(index, 1);
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.model.uploadFiles.filter(x => {
          return x.fileId != idFile;
        });
        this.model.uploadFiles = resultData;
      }
    },

    // Search
    handleSearch() {
      this.$refs.tblList.refresh();
    },
    clearSearch() {
      this.itemFilter.title = null;
      this.itemFilter.loaiVanBan = null;
      this.itemFilter.linhVuc = null;
      this.$refs.tblList.refresh();
    },

    // Select from VanBanDi
    handleShowSelectVBDi() {
      this.filterVBDi = null;
      this.filterLoaiVBDi = null;
      this.filterLinhVucDi = null;
      this.currentPageVBDi = 1;
      this.showSelectVBDiModal = true;
      this.searchVanBanDi();
    },
    async searchVanBanDi() {
      this.loadingVBDi = true;
      const params = {
        start: this.currentPageVBDi,
        limit: this.perPageVBDi,
        content: this.filterVBDi,
        loaiVanBan: this.filterLoaiVBDi ? this.filterLoaiVBDi.id : null,
        linhVuc: this.filterLinhVucDi ? this.filterLinhVucDi.id : null,
      };
      await this.$store.dispatch("vanBanNoiBoStore/getAllVanBanDi", params).then((res) => {
        if (res.data) {
          this.listVanBanDi = res.data.data || [];
          this.totalRowsVBDi = res.data.totalRows;
        }
      }).finally(() => {
        this.loadingVBDi = false;
      });
    },
    onPageChangeVBDi(page) {
      this.currentPageVBDi = page;
      this.searchVanBanDi();
    },
    handleSelectVanBanDi(vanBanDiId) {
      const item = this.listVanBanDi.find(x => x.id === vanBanDiId);
      if (!item) return;

      // Collect files
      let files = [];
      // File ký số: lấy file cuối cùng từ FilePDF
      if (item.filePDF && item.filePDF.length > 0) {
        files.push(item.filePDF[item.filePDF.length - 1]);
      }
      // File đính kèm
      if (item.file && item.file.length > 0) {
        files = files.concat(item.file);
      }
      if (item.phuLucDinhKem && item.phuLucDinhKem.length > 0) {
        files = files.concat(item.phuLucDinhKem);
      }

      this.model = {
        ...vanBanNoiBoModel.baseJson(),
        trichYeu: item.trichYeu,
        soVanBan: item.soVBDi,
        ngayBanHanh: item.ngayBanHanh ? moment(item.ngayBanHanh).format('DD/MM/YYYY') : null,
        loaiVanBan: item.loaiVanBan,
        linhVuc: item.linhVuc,
        donViBanHanh: item.donViSoan,
        nguoiKy: item.nguoiKy,
        file: files.length > 0 ? files : null,
        nguonVanBanId: item.id,
        nguonVanBanLoai: 'VanBanDi',
      };

      this.showSelectVBDiModal = false;
      this.submitted = false;
      this.showModal = true;
    },

    // Select from VanBanDen
    handleShowSelectVBDen() {
      this.filterVBDen = null;
      this.filterLoaiVBDen = null;
      this.filterLinhVucDen = null;
      this.currentPageVBDen = 1;
      this.showSelectVBDenModal = true;
      this.searchVanBanDen();
    },
    async searchVanBanDen() {
      this.loadingVBDen = true;
      const params = {
        start: this.currentPageVBDen,
        limit: this.perPageVBDen,
        content: this.filterVBDen,
        loaiVanBan: this.filterLoaiVBDen ? this.filterLoaiVBDen.id : null,
        linhVuc: this.filterLinhVucDen ? this.filterLinhVucDen.id : null,
      };
      await this.$store.dispatch("vanBanNoiBoStore/getAllVanBanDen", params).then((res) => {
        if (res.data) {
          this.listVanBanDen = res.data.data || [];
          this.totalRowsVBDen = res.data.totalRows;
        }
      }).finally(() => {
        this.loadingVBDen = false;
      });
    },
    onPageChangeVBDen(page) {
      this.currentPageVBDen = page;
      this.searchVanBanDen();
    },
    handleSelectVanBanDen(vanBanDenId) {
      const item = this.listVanBanDen.find(x => x.id === vanBanDenId);
      if (!item) return;

      // File đính kèm
      let files = [];
      if (item.file && item.file.length > 0) {
        files = files.concat(item.file);
      }

      this.model = {
        ...vanBanNoiBoModel.baseJson(),
        trichYeu: item.trichYeu,
        soVanBan: item.soVBDen,
        ngayBanHanh: item.ngayBanHanh ? moment(item.ngayBanHanh).format('DD/MM/YYYY') : null,
        loaiVanBan: item.loaiVanBan,
        linhVuc: item.linhVuc,
        donViBanHanh: item.donViSoan,
        nguoiKy: item.nguoiKy,
        file: files.length > 0 ? files : null,
        nguonVanBanId: item.id,
        nguonVanBanLoai: 'VanBanDen',
      };

      this.showSelectVBDenModal = false;
      this.submitted = false;
      this.showModal = true;
    },

    // Dropdown data
    async getLoaiVanBan() {
      await this.$store.dispatch("loaiVanBanStore/getAll").then((res) => {
        if (res.resultCode === "SUCCESS") {
          this.optionsLoaiVanBan = res.data;
        } else {
          this.optionsLoaiVanBan = [];
        }
      });
    },
    async getLinhVuc() {
      try {
        await this.$store.dispatch("dmLinhVucStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            this.optionsLinhVuc = resp.data;
          }
        });
      } finally {
        this.loading = false;
      }
    },
    async getDonVi() {
      try {
        await this.$store.dispatch("donViStore/get").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            this.optionsDonVi = resp.data;
          }
        });
      } finally {
        this.loading = false;
      }
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            this.optionsUser = resp.data;
          }
        });
      } finally {
        this.loading = false;
      }
    },
    formatDate(date) {
      if (!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },

    // File preview
    openFilePreview(files, index) {
      if (!files || files.length === 0) return;
      this.previewFiles = files;
      this.activePreviewIndex = index || 0;
      this.previewError = false;
      this.showFilePreview = true;
      this.loadPreviewBlob(files[this.activePreviewIndex]);
    },
    selectPreviewFile(index) {
      this.activePreviewIndex = index;
      this.previewError = false;
      this.loadPreviewBlob(this.previewFiles[index]);
    },
    getAuthToken() {
      try {
        return JSON.parse(localStorage.getItem('user-token'));
      } catch {
        return localStorage.getItem('user-token');
      }
    },
    async loadPreviewBlob(file) {
      if (!file) return;
      if (this.previewBlobUrl) {
        URL.revokeObjectURL(this.previewBlobUrl);
        this.previewBlobUrl = null;
      }
      this.previewLoading = true;
      this.previewError = false;
      try {
        const token = this.getAuthToken();
        const headers = {};
        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }
        const response = await fetch(`${this.apiUrl}files/view/${file.fileId}`, { headers });
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        const blob = await response.blob();
        const ext = (file.ext || '').toLowerCase();
        const mimeMap = {
          '.pdf': 'application/pdf',
          '.png': 'image/png',
          '.jpg': 'image/jpeg',
          '.jpeg': 'image/jpeg',
          '.gif': 'image/gif',
          '.bmp': 'image/bmp',
          '.svg': 'image/svg+xml',
        };
        let blobWithType = blob;
        if (mimeMap[ext]) {
          blobWithType = new Blob([blob], { type: mimeMap[ext] });
        }
        this.previewBlobUrl = URL.createObjectURL(blobWithType);
      } catch (e) {
        console.error('Error loading file preview:', e);
        this.previewBlobUrl = null;
        this.previewError = true;
      } finally {
        this.previewLoading = false;
      }
    },
    closeFilePreview() {
      this.showFilePreview = false;
      if (this.previewBlobUrl) {
        URL.revokeObjectURL(this.previewBlobUrl);
        this.previewBlobUrl = null;
      }
    },
    isImageFile(file) {
      if (!file) return false;
      const ext = (file.ext || '').toLowerCase();
      return ['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'].includes(ext);
    },
    isPdfFile(file) {
      if (!file) return false;
      return (file.ext || '').toLowerCase() === '.pdf';
    },
    canPreviewFile(file) {
      if (!file) return false;
      const ext = (file.ext || '').toLowerCase();
      return ['.pdf', '.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'].includes(ext);
    },
    downloadFile(file) {
      if (!file) return;
      window.open(`${this.apiUrl}files/view/${file.fileId}`, '_blank');
    },
    openPreviewInNewTab() {
      if (this.previewBlobUrl) {
        window.open(this.previewBlobUrl, '_blank');
      }
    },
    getFileIcon(file) {
      if (!file) return 'mdi mdi-file-outline';
      const ext = (file.ext || '').toLowerCase();
      if (ext === '.pdf') return 'mdi mdi-file-pdf-box';
      if (['.doc', '.docx'].includes(ext)) return 'mdi mdi-file-word-box';
      if (['.xls', '.xlsx', '.csv'].includes(ext)) return 'mdi mdi-file-excel-box';
      if (['.pptx'].includes(ext)) return 'mdi mdi-file-powerpoint-box';
      if (['.zip', '.rar'].includes(ext)) return 'mdi mdi-zip-box';
      if (['.png', '.jpg', '.jpeg', '.gif', '.bmp', '.svg'].includes(ext)) return 'mdi mdi-file-image';
      return 'mdi mdi-file-outline';
    },
  }
};
</script>

<template>
  <div>
    <!-- Header card with search toggle -->
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> Văn bản nội bộ</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <b-button v-b-toggle.collapseSearch variant="light"
                          class="btn w-md btn-primary-outline me-2" size="sm">
                  <i class="fas fa-caret-down align-middle me-2"></i>
                  Tìm kiếm
                </b-button>
                <b-dropdown v-if="isAdmin" right variant="primary" size="sm" class="me-2" menu-class="dropdown-menu-end">
                  <template v-slot:button-content>
                    <i class="mdi mdi-plus align-middle me-1"></i> Thao tác
                  </template>
                  <b-dropdown-item @click="handleCreate">
                    <i class="mdi mdi-plus me-2"></i> Thêm mới
                  </b-dropdown-item>
                  <b-dropdown-item @click="handleShowSelectVBDi">
                    <i class="mdi mdi-file-export-outline me-2"></i> Chọn từ VB đi
                  </b-dropdown-item>
                  <b-dropdown-item @click="handleShowSelectVBDen">
                    <i class="mdi mdi-file-import-outline me-2"></i> Chọn từ VB đến
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label>Nội dung</label>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          v-model="itemFilter.title"
                          placeholder="Trích yếu/Số văn bản/..."
                      />
                    </div>
                    <!-- Loại văn bản -->
                    <div class="flex-grow-1 me-2">
                      <label>Loại văn bản</label>
                      <multiselect
                          v-model="itemFilter.loaiVanBan"
                          :options="optionsLoaiVanBan"
                          track-by="id"
                          selectLabel="Nhấn vào để chọn"
                          deselectLabel="Nhấn vào để xóa"
                          class="helo"
                          label="ten"
                          placeholder="Chọn loại văn bản"
                      ></multiselect>
                    </div>
                    <!-- Lĩnh vực -->
                    <div class="flex-grow-1 me-2">
                      <label>Lĩnh vực</label>
                      <multiselect
                          v-model="itemFilter.linhVuc"
                          :options="optionsLinhVuc"
                          track-by="id"
                          selectLabel="Nhấn vào để chọn"
                          deselectLabel="Nhấn vào để xóa"
                          label="ten"
                          placeholder="Chọn lĩnh vực"
                      ></multiselect>
                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>

    <!-- Table card -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <!-- Modal Create/Update -->
                  <b-modal
                      v-model="showModal"
                      :title="model.id ? 'Cập nhật văn bản nội bộ' : 'Thêm mới văn bản nội bộ'"
                      title-class="fw-bold fs-5 text-dark"
                      body-class="p-3"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="xl"
                  >
                    <template #modal-header="{  }">
                      <h5 class="fw-bold fs-5 text-primary"> Văn bản nội bộ</h5>
                      <div class="text-end">
                        <b-button variant="light" size="sm" style="width: 80px" @click="showModal = false">
                          Đóng
                        </b-button>
                        <b-button v-if="showButtonSave" type="submit" variant="primary" class="ms-1" style="width: 80px"
                                  size="sm"
                                  @click="handleSubmit"
                        >
                          Lưu
                        </b-button>
                      </div>
                    </template>
                    <form @submit.prevent="handleSubmit" ref="formContainer">
                      <div class="row">
                        <div class="col-md-7">
                          <div class="row">
                            <!-- Số văn bản -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label">Số văn bản</label>
                                <input
                                    v-model="model.soVanBan"
                                    type="text"
                                    class="form-control"
                                    placeholder="Nhập số văn bản"
                                />
                              </div>
                            </div>
                            <!-- Loại văn bản -->
                            <div class="col-md-6">
                              <div class="mb-2">
                                <label class="form-label">Loại văn bản</label>
                                <span class="text-danger">*</span>
                                <multiselect
                                    v-model="model.loaiVanBan"
                                    :options="optionsLoaiVanBan"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn loại văn bản"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                    :class="{'is-invalid-select': submitted && $v.model.loaiVanBan.$error}"
                                ></multiselect>
                                <div v-if="submitted && $v.model.loaiVanBan.$error" class="text-danger small mt-1">
                                  <span v-if="!$v.model.loaiVanBan.required">Vui lòng chọn loại văn bản.</span>
                                </div>
                              </div>
                            </div>
                            <!-- Trích yếu -->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label">Trích yếu / Mô tả</label>
                                <span class="text-danger">*</span>
                                <textarea
                                    v-model="model.trichYeu"
                                    class="form-control"
                                    rows="4"
                                    placeholder="Nhập trích yếu hoặc mô tả văn bản"
                                    :class="{'is-invalid': submitted && $v.model.trichYeu.$error}"
                                ></textarea>
                                <div v-if="submitted && $v.model.trichYeu.$error" class="invalid-feedback">
                                  <span v-if="!$v.model.trichYeu.required">Vui lòng nhập trích yếu.</span>
                                </div>
                              </div>
                            </div>
                            <!-- File đã có -->
                            <div v-if="model.file && model.file.length > 0" class="col-md-12">
                              <label>Danh sách tệp tin (Nhấn vào để xem trước)</label>
                              <div class="p-1">
                                <div v-for="(file, index) in model.file" :key="index"
                                     class="bg-body mb-1 px-2 d-flex align-items-center" style="width: fit-content">
                                  <a href="javascript:void(0)" class="fw-medium"
                                     @click="openFilePreview(model.file, index)">
                                    <i :class="getFileIcon(file)" class="font-size-16 align-middle me-2"></i>
                                    {{ index + 1 }}: {{ file.fileName }}
                                  </a>
                                  <button type="button" class="btn btn-sm text-danger ms-2 p-0"
                                          @click="removeExistingFile(index)"
                                          title="Xóa tệp tin">
                                    <i class="fas fa-times"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <!-- Upload file -->
                            <div class="col-md-12">
                              <label>File đính kèm</label>
                              <span class="text-danger">*</span>
                              <div v-if="submitted && !hasFiles()" class="text-danger small mb-1">
                                Vui lòng đính kèm ít nhất một tệp tin.
                              </div>
                              <vue-dropzone
                                  id="dropzone"
                                  ref="myVueDropzone"
                                  :use-custom-slot="true"
                                  :options="dropzoneOptions"
                                  v-on:vdropzone-removed-file="removeThisFile"
                                  v-on:vdropzone-success="addThisFile"
                              >
                                <div class="dropzone-custom-content">
                                  <i class="display-1 text-muted bx bxs-cloud-upload" style="font-size: 70px"></i>
                                  <h4>Kéo thả tệp tin hoặc bấm vào để tải tệp tin</h4>
                                </div>
                              </vue-dropzone>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-5">
                          <div class="row">
                            <!-- Lĩnh vực -->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label">Lĩnh vực</label>
                                <span class="text-danger">*</span>
                                <multiselect
                                    v-model="model.linhVuc"
                                    :options="optionsLinhVuc"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn lĩnh vực"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                    :class="{'is-invalid-select': submitted && $v.model.linhVuc.$error}"
                                ></multiselect>
                                <div v-if="submitted && $v.model.linhVuc.$error" class="text-danger small mt-1">
                                  <span v-if="!$v.model.linhVuc.required">Vui lòng chọn lĩnh vực.</span>
                                </div>
                              </div>
                            </div>
                            <!-- Đơn vị ban hành -->
                            <div class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label">Đơn vị ban hành</label>
                                <multiselect
                                    v-model="model.donViBanHanh"
                                    :options="optionsDonVi"
                                    track-by="id"
                                    label="ten"
                                    placeholder="Chọn đơn vị"
                                    deselect-label="Nhấn để xoá"
                                    selectLabel="Nhấn enter để chọn"
                                    selectedLabel="Đã chọn"
                                ></multiselect>
                              </div>
                            </div>
                            <!-- Nguồn gốc -->
                            <div v-if="model.nguonVanBanId" class="col-md-12">
                              <div class="mb-2">
                                <label class="form-label">Nguồn gốc</label>
                                <div class="text-muted">
                                  Sao chép từ <strong>{{ model.nguonVanBanLoai === 'VanBanDi' ? 'Văn bản đi' : 'Văn bản đến' }}</strong>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <!-- Table -->
                <div class="table-responsive-sm table-responsive">
                  <b-table
                      class="datatables"
                      :items="myProvider"
                      :fields="computedFields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      no-local-sorting
                      no-sort-reset
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-vbd"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(trichYeu)="data">
                      <div v-if="data.item.trichYeu"
                           style="font-weight: normal !important; cursor: pointer; color: #495057;"
                           @click="handleShowDetail(data.item.id)"
                           class="text-hover-primary">
                        {{ data.item.trichYeu }}
                      </div>
                    </template>
                    <template v-slot:cell(loaiVanBan)="data">
                      <span v-if="data.item.loaiVanBan">{{ data.item.loaiVanBan.ten }}</span>
                    </template>
                    <template v-slot:cell(linhVuc)="data">
                      <span v-if="data.item.linhVuc">{{ data.item.linhVuc.ten }}</span>
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          class="btn btn-detail btn-sm"
                          data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                          v-on:click="handleUpdate(data.item.id)"
                      >
                        <i class="fas fa-eye"></i>
                      </button>
                      <b-dropdown
                          id="dropdown-right"
                          right
                          variant="outline"
                          class="cs-btn-dropdown"
                          menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          ...
                        </template>
                        <b-dropdown-item
                            v-on:click="handleUpdate(data.item.id)"
                        >
                          <div class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-edit"
                                data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                                v-on:click="handleUpdate(data.item.id)">
                              <i class="fas fa-pencil-alt"></i>
                            </button>
                            <span class="ms-2">Chỉnh sửa</span>
                          </div>
                        </b-dropdown-item>
                        <b-dropdown-item
                            v-on:click="handleShowDeleteModal(data.item.id)"
                        >
                          <div class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-delete"
                                data-toggle="tooltip" data-placement="bottom" title="Xóa"
                                v-on:click="handleShowDeleteModal(data.item.id)">
                              <i class="fas fa-trash-alt"></i>
                            </button>
                            <span class="ms-2">Xóa</span>
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">Đang tải dữ liệu</div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
              </div>
            </div>

            <!-- Pagination -->
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal Detail -->
    <b-modal
        v-model="showDetail"
        title-class="fw-bold fs-5 text-dark"
        centered
        hide-footer
        no-close-on-backdrop
        size="lg"
    >
      <template #modal-header="{}">
        <h5 class="fw-bold fs-5 text-primary mb-0">Chi tiết văn bản nội bộ</h5>
        <div>
          <b-button variant="light" size="sm" style="width: 80px" @click="showDetail = false">
            Đóng
          </b-button>
          <b-button v-if="isAdmin" variant="primary" size="sm" class="ms-1" style="width: 80px"
                    @click="showDetail = false; handleUpdate(detailModel.id)">
            Sửa
          </b-button>
        </div>
      </template>
      <div v-if="detailModel">
        <!-- Trích yếu -->
        <div class="mb-3">
          <div class="text-muted small mb-1">Trích yếu</div>
          <div class="fw-medium" v-html="detailModel.trichYeu || '—'"></div>
        </div>
        <hr class="my-2"/>
        <div class="row">
          <!-- Loại văn bản -->
          <div class="col-md-6 mb-3">
            <div class="text-muted small mb-1">Loại văn bản</div>
            <div class="fw-medium">{{ detailModel.loaiVanBan ? detailModel.loaiVanBan.ten : '—' }}</div>
          </div>
          <!-- Lĩnh vực -->
          <div class="col-md-6 mb-3">
            <div class="text-muted small mb-1">Lĩnh vực</div>
            <div class="fw-medium">{{ detailModel.linhVuc ? detailModel.linhVuc.ten : '—' }}</div>
          </div>
          <!-- Đơn vị ban hành -->
          <div class="col-md-6 mb-3">
            <div class="text-muted small mb-1">Đơn vị ban hành</div>
            <div class="fw-medium">{{ detailModel.donViBanHanh ? detailModel.donViBanHanh.ten : '—' }}</div>
          </div>
          <!-- Nguồn gốc -->
          <div v-if="detailModel.nguonVanBanId" class="col-md-6 mb-3">
            <div class="text-muted small mb-1">Nguồn gốc</div>
            <div class="fw-medium">
              Sao chép từ <strong>{{ detailModel.nguonVanBanLoai === 'VanBanDi' ? 'Văn bản đi' : 'Văn bản đến' }}</strong>
            </div>
          </div>
        </div>
        <!-- File đính kèm -->
        <div v-if="detailModel.file && detailModel.file.length > 0">
          <hr class="my-2"/>
          <div class="text-muted small mb-2">Tệp tin đính kèm</div>
          <div v-for="(file, index) in detailModel.file" :key="index" class="mb-1">
            <a href="javascript:void(0)" class="text-primary"
               @click="openFilePreview(detailModel.file, index)">
              <i :class="getFileIcon(file)" class="me-1"></i>
              {{ file.fileName }}
            </a>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal Delete -->
    <b-modal v-model="showDeleteModal" centered title="Xác nhận xóa" hide-footer>
      <div class="text-center">
        <p>Bạn có chắc chắn muốn xóa văn bản này?</p>
        <div class="mt-3">
          <b-button variant="light" @click="showDeleteModal = false" class="me-2">Hủy</b-button>
          <b-button variant="danger" @click="handleDelete">Xóa</b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal Select VanBanDi -->
    <b-modal
        v-model="showSelectVBDiModal"
        title="Chọn từ văn bản đi"
        title-class="fw-bold fs-5 text-dark"
        centered
        hide-footer
        no-close-on-backdrop
        size="lg"
    >
      <div class="mb-3">
        <div class="row mb-2">
          <div class="col-12">
            <input
                v-model="filterVBDi"
                type="text"
                class="form-control"
                placeholder="Trích yếu, số văn bản ..."
            />
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-5">
            <multiselect
                v-model="filterLoaiVBDi"
                :options="optionsLoaiVanBan"
                track-by="id"
                label="ten"
                placeholder="Loại văn bản"
                deselect-label="Nhấn để xoá"
                selectLabel=""
                selectedLabel=""
                :allow-empty="true"
            ></multiselect>
          </div>
          <div class="col-md-5">
            <multiselect
                v-model="filterLinhVucDi"
                :options="optionsLinhVuc"
                track-by="id"
                label="ten"
                placeholder="Lĩnh vực"
                deselect-label="Nhấn để xoá"
                selectLabel=""
                selectedLabel=""
                :allow-empty="true"
            ></multiselect>
          </div>
          <div class="col-md-2">
            <b-button variant="primary" class="w-100" :disabled="loadingVBDi" @click="currentPageVBDi = 1; searchVanBanDi()">
              <i v-if="loadingVBDi" class="spinner-border spinner-border-sm me-1"></i>
              <i v-else class="fas fa-search me-1"></i> Tìm kiếm
            </b-button>
          </div>
        </div>
      </div>
      <div class="table-responsive position-relative">
        <div v-if="loadingVBDi" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style="z-index: 1; background: rgba(255,255,255,0.7);">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Đang tải...</span>
          </div>
        </div>
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>STT</th>
            <th>Số VB</th>
            <th>Trích yếu</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in listVanBanDi" :key="item.id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>{{ item.soVBDi }}</td>
            <td v-html="item.trichYeu"></td>
            <td class="text-center">
              <b-button size="sm" variant="primary" @click="handleSelectVanBanDi(item.id)">
                Chọn
              </b-button>
            </td>
          </tr>
          <tr v-if="!loadingVBDi && listVanBanDi.length === 0">
            <td colspan="4" class="text-center">Không có dữ liệu</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-2">
        <div class="col-sm-6">
          <div>Hiển thị {{ listVanBanDi.length }} trên tổng số {{ totalRowsVBDi }} dòng</div>
        </div>
        <div class="col-sm-6">
          <div class="float-end">
            <b-pagination
                v-model="currentPageVBDi"
                :total-rows="totalRowsVBDi"
                :per-page="perPageVBDi"
                size="sm"
                @change="onPageChangeVBDi"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal Select VanBanDen -->
    <b-modal
        v-model="showSelectVBDenModal"
        title="Chọn từ văn bản đến"
        title-class="fw-bold fs-5 text-dark"
        centered
        hide-footer
        no-close-on-backdrop
        size="lg"
    >
      <div class="mb-3">
        <div class="row mb-2">
          <div class="col-12">
            <input
                v-model="filterVBDen"
                type="text"
                class="form-control"
                placeholder="Trích yếu, số văn bản ..."
            />
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-5">
            <multiselect
                v-model="filterLoaiVBDen"
                :options="optionsLoaiVanBan"
                track-by="id"
                label="ten"
                placeholder="Loại văn bản"
                deselect-label="Nhấn để xoá"
                selectLabel=""
                selectedLabel=""
                :allow-empty="true"
            ></multiselect>
          </div>
          <div class="col-md-5">
            <multiselect
                v-model="filterLinhVucDen"
                :options="optionsLinhVuc"
                track-by="id"
                label="ten"
                placeholder="Lĩnh vực"
                deselect-label="Nhấn để xoá"
                selectLabel=""
                selectedLabel=""
                :allow-empty="true"
            ></multiselect>
          </div>
          <div class="col-md-2">
            <b-button variant="primary" class="w-100" :disabled="loadingVBDen" @click="currentPageVBDen = 1; searchVanBanDen()">
              <i v-if="loadingVBDen" class="spinner-border spinner-border-sm me-1"></i>
              <i v-else class="fas fa-search me-1"></i> Tìm kiếm
            </b-button>
          </div>
        </div>
      </div>
      <div class="table-responsive position-relative">
        <div v-if="loadingVBDen" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center" style="z-index: 1; background: rgba(255,255,255,0.7);">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Đang tải...</span>
          </div>
        </div>
        <table class="table table-bordered table-hover">
          <thead>
          <tr>
            <th>STT</th>
            <th>Số VB đến</th>
            <th>Trích yếu</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in listVanBanDen" :key="item.id">
            <td class="text-center">{{ index + 1 }}</td>
            <td>{{ item.soVBDen }}</td>
            <td v-html="item.trichYeu"></td>
            <td class="text-center">
              <b-button size="sm" variant="primary" @click="handleSelectVanBanDen(item.id)">
                Chọn
              </b-button>
            </td>
          </tr>
          <tr v-if="!loadingVBDen && listVanBanDen.length === 0">
            <td colspan="4" class="text-center">Không có dữ liệu</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="row mt-2">
        <div class="col-sm-6">
          <div>Hiển thị {{ listVanBanDen.length }} trên tổng số {{ totalRowsVBDen }} dòng</div>
        </div>
        <div class="col-sm-6">
          <div class="float-end">
            <b-pagination
                v-model="currentPageVBDen"
                :total-rows="totalRowsVBDen"
                :per-page="perPageVBDen"
                size="sm"
                @change="onPageChangeVBDen"
            ></b-pagination>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal File Preview (Full Screen) -->
    <b-modal
        v-model="showFilePreview"
        hide-header
        hide-footer
        no-close-on-backdrop
        modal-class="file-preview-modal"
        dialog-class="file-preview-dialog"
        content-class="file-preview-content"
        body-class="p-0"
        size="xl"
        @hidden="closeFilePreview"
    >
      <div class="fp-wrapper">
        <!-- Sidebar -->
        <div class="fp-sidebar">
          <div class="fp-sidebar-header">
            <span class="fp-sidebar-title">Tệp đính kèm</span>
            <span class="fp-sidebar-count">{{ previewFiles.length }}</span>
          </div>
          <div class="fp-sidebar-list">
            <div
                v-for="(file, index) in previewFiles"
                :key="index"
                class="fp-file-item"
                :class="{ 'fp-file-active': activePreviewIndex === index }"
                @click="selectPreviewFile(index)"
            >
              <div class="fp-file-icon-wrap">
                <i :class="getFileIcon(file)" class="fp-file-icon"></i>
              </div>
              <div class="fp-file-meta">
                <div class="fp-file-name" :title="file.fileName">{{ file.fileName }}</div>
                <div class="fp-file-ext">{{ (file.ext || '').toUpperCase().replace('.', '') }}</div>
              </div>
            </div>
          </div>
          <!-- Sidebar navigation -->
          <div v-if="previewFiles.length > 1" class="fp-sidebar-nav">
            <button class="fp-nav-btn" :disabled="activePreviewIndex === 0" @click="selectPreviewFile(activePreviewIndex - 1)">
              <i class="mdi mdi-chevron-left"></i>
            </button>
            <span class="fp-nav-text">{{ activePreviewIndex + 1 }} / {{ previewFiles.length }}</span>
            <button class="fp-nav-btn" :disabled="activePreviewIndex === previewFiles.length - 1" @click="selectPreviewFile(activePreviewIndex + 1)">
              <i class="mdi mdi-chevron-right"></i>
            </button>
          </div>
        </div>

        <!-- Main preview -->
        <div class="fp-main">
          <!-- Top bar -->
          <div class="fp-topbar">
            <div class="fp-topbar-info" v-if="previewFiles[activePreviewIndex]">
              <i :class="getFileIcon(previewFiles[activePreviewIndex])" class="fp-topbar-icon"></i>
              <span class="fp-topbar-name">{{ previewFiles[activePreviewIndex].fileName }}</span>
            </div>
            <div class="fp-topbar-actions">
              <button v-if="previewFiles[activePreviewIndex]" class="fp-action-btn" @click="downloadFile(previewFiles[activePreviewIndex])" title="Tải xuống">
                <i class="mdi mdi-download"></i>
              </button>
              <button v-if="previewBlobUrl" class="fp-action-btn" @click="openPreviewInNewTab()" title="Mở tab mới">
                <i class="mdi mdi-open-in-new"></i>
              </button>
              <button class="fp-close-btn" @click="closeFilePreview" title="Đóng (ESC)">
                <i class="mdi mdi-close"></i>
              </button>
            </div>
          </div>

          <!-- Content area -->
          <div class="fp-content">
            <!-- Loading state -->
            <div v-if="previewLoading" class="fp-state-center">
              <div class="fp-spinner"></div>
              <p class="fp-state-text">Đang tải tệp tin...</p>
            </div>

            <!-- Error state -->
            <div v-else-if="previewError" class="fp-state-center">
              <div class="fp-state-icon-error">
                <i class="mdi mdi-alert-circle-outline"></i>
              </div>
              <p class="fp-state-title">Không thể tải tệp tin</p>
              <p class="fp-state-text">Vui lòng thử tải xuống hoặc mở trong tab mới</p>
              <div class="fp-state-actions">
                <button class="btn btn-sm btn-outline-primary me-2" @click="loadPreviewBlob(previewFiles[activePreviewIndex])">
                  <i class="mdi mdi-refresh me-1"></i> Thử lại
                </button>
                <button class="btn btn-sm btn-primary" @click="downloadFile(previewFiles[activePreviewIndex])">
                  <i class="mdi mdi-download me-1"></i> Tải xuống
                </button>
              </div>
            </div>

            <!-- Preview: Image -->
            <div v-else-if="previewBlobUrl && isImageFile(previewFiles[activePreviewIndex])" class="fp-image-wrap">
              <img :src="previewBlobUrl" class="fp-image" />
            </div>

            <!-- Preview: PDF / supported files -->
            <iframe
                v-else-if="previewBlobUrl && canPreviewFile(previewFiles[activePreviewIndex])"
                :src="previewBlobUrl"
                class="fp-iframe"
                frameborder="0"
                allowfullscreen
            ></iframe>

            <!-- Unsupported format -->
            <div v-else-if="!previewLoading && !canPreviewFile(previewFiles[activePreviewIndex])" class="fp-state-center">
              <div class="fp-state-icon-warn">
                <i class="mdi mdi-file-question-outline"></i>
              </div>
              <p class="fp-state-title">Không hỗ trợ xem trước</p>
              <p class="fp-state-text">Định dạng {{ (previewFiles[activePreviewIndex].ext || '').toUpperCase() }} chưa được hỗ trợ</p>
              <button class="btn btn-sm btn-primary" @click="downloadFile(previewFiles[activePreviewIndex])">
                <i class="mdi mdi-download me-1"></i> Tải xuống tệp tin
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style>
.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}
.modal-open {
  overflow: hidden !important;
  padding-right: 0 !important;
}
.modal {
  overflow-y: auto !important;
}
.text-hover-primary:hover {
  color: #00568C !important;
  text-decoration: underline;
}
.is-invalid-select .multiselect__tags {
  border-color: #f46a6a !important;
}

/* File Preview Modal */
.file-preview-modal .modal-dialog {
  max-width: 100vw !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
}
.file-preview-modal .modal-content {
  height: 100vh !important;
  border: none !important;
  border-radius: 0 !important;
}
.file-preview-modal .modal-body {
  height: 100vh !important;
  overflow: hidden !important;
}
.fp-wrapper {
  display: flex;
  height: 100vh;
  background: #fff;
}

/* Sidebar - Primary color #00568C */
.fp-sidebar {
  width: 272px;
  min-width: 272px;
  background: #00568C;
  display: flex;
  flex-direction: column;
}
.fp-sidebar-header {
  padding: 16px 20px;
  border-bottom: 1px solid rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.fp-sidebar-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}
.fp-sidebar-count {
  background: rgba(255,255,255,0.2);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 10px;
}
.fp-sidebar-list {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
}
.fp-file-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-bottom: 2px;
  transition: background 0.15s;
}
.fp-file-item:hover {
  background: rgba(255,255,255,0.1);
}
.fp-file-active {
  background: rgba(255,255,255,0.18) !important;
}
.fp-file-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}
.fp-file-active .fp-file-icon-wrap {
  background: #fff;
}
.fp-file-icon {
  font-size: 18px;
  color: rgba(255,255,255,0.7);
}
.fp-file-active .fp-file-icon {
  color: #00568C;
}
.fp-file-meta {
  flex: 1;
  min-width: 0;
}
.fp-file-name {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255,255,255,0.85);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
}
.fp-file-active .fp-file-name {
  color: #fff;
  font-weight: 600;
}
.fp-file-ext {
  font-size: 11px;
  color: rgba(255,255,255,0.5);
  margin-top: 1px;
}
.fp-sidebar-nav {
  padding: 10px 16px;
  border-top: 1px solid rgba(255,255,255,0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-shrink: 0;
}
.fp-nav-btn {
  width: 28px;
  height: 28px;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 6px;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  transition: all 0.15s;
}
.fp-nav-btn:hover:not(:disabled) {
  background: rgba(255,255,255,0.15);
  border-color: rgba(255,255,255,0.5);
}
.fp-nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}
.fp-nav-text {
  font-size: 12px;
  color: rgba(255,255,255,0.7);
  font-weight: 500;
}

/* Main area */
.fp-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #f9fafb;
}
.fp-topbar {
  height: 48px;
  padding: 0 16px;
  background: #fff;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.fp-topbar-info {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}
.fp-topbar-icon {
  font-size: 20px;
  color: #00568C;
  margin-right: 8px;
  flex-shrink: 0;
}
.fp-topbar-name {
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.fp-topbar-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-left: 16px;
}
.fp-action-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6b7280;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}
.fp-action-btn:hover {
  background: #f3f4f6;
  color: #00568C;
}
.fp-close-btn {
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #6b7280;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  margin-left: 4px;
}
.fp-close-btn:hover {
  background: #fee2e2;
  color: #ef4444;
}

/* Content */
.fp-content {
  flex: 1;
  position: relative;
  overflow: hidden;
}
.fp-iframe {
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
}
.fp-image-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  background: #f3f4f6;
  padding: 24px;
}
.fp-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1), 0 4px 16px rgba(0,0,0,0.08);
}

/* States */
.fp-state-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px;
}
.fp-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #e5e7eb;
  border-top-color: #00568C;
  border-radius: 50%;
  animation: fp-spin 0.7s linear infinite;
}
@keyframes fp-spin {
  to { transform: rotate(360deg); }
}
.fp-state-icon-error {
  font-size: 48px;
  color: #ef4444;
  line-height: 1;
  margin-bottom: 8px;
}
.fp-state-icon-warn {
  font-size: 48px;
  color: #9ca3af;
  line-height: 1;
  margin-bottom: 8px;
}
.fp-state-title {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin: 8px 0 4px;
}
.fp-state-text {
  font-size: 13px;
  color: #6b7280;
  margin: 4px 0 16px;
}
.fp-state-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ===== RESPONSIVE ===== */

/* Table page responsive */
@media (max-width: 767.98px) {
  .col-md-4.d-flex.align-items-center {
    margin-bottom: 8px;
  }
  .col-md-8.text-end {
    text-align: left !important;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .d-flex.justify-content-between.align-items-end.flex-wrap {
    flex-direction: column;
    align-items: stretch !important;
  }
  .d-flex.justify-content-between.align-items-end.flex-wrap > div {
    margin-right: 0 !important;
    margin-left: 0 !important;
    margin-bottom: 8px;
    width: 100%;
  }
  .d-flex.justify-content-between.align-items-end.flex-wrap > div:last-child {
    margin-bottom: 0;
  }
  .d-flex.justify-content-between.align-items-center.flex-wrap {
    gap: 8px;
  }
  .dataTables_paginate {
    float: none !important;
    margin-top: 8px;
  }
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}

/* File Preview responsive */
@media (max-width: 767.98px) {
  .fp-wrapper {
    flex-direction: column;
    height: 100vh;
  }
  .fp-sidebar {
    width: 100%;
    min-width: 100%;
    max-height: 160px;
    flex-direction: column;
  }
  .fp-sidebar-header {
    padding: 10px 14px;
  }
  .fp-sidebar-list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 6px 8px;
    gap: 4px;
  }
  .fp-file-item {
    flex-shrink: 0;
    min-width: 160px;
    max-width: 200px;
    margin-bottom: 0;
    padding: 8px 10px;
  }
  .fp-sidebar-nav {
    display: none;
  }
  .fp-main {
    flex: 1;
    min-height: 0;
  }
  .fp-topbar {
    height: 42px;
    padding: 0 10px;
  }
  .fp-topbar-name {
    font-size: 12px;
    max-width: 150px;
  }
  .fp-topbar-actions {
    margin-left: 8px;
  }
  .fp-action-btn,
  .fp-close-btn {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
}

@media (max-width: 575.98px) {
  .fp-sidebar {
    max-height: 130px;
  }
  .fp-file-item {
    min-width: 140px;
    padding: 6px 8px;
  }
  .fp-file-icon-wrap {
    width: 30px;
    height: 30px;
    margin-right: 8px;
  }
  .fp-file-icon {
    font-size: 15px;
  }
  .fp-file-name {
    font-size: 12px;
  }
  .fp-file-ext {
    font-size: 10px;
  }
}
</style>
